import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=2bb4da51&scoped=true&"
import script from "./Home.vue?vue&type=script&lang=js&"
export * from "./Home.vue?vue&type=script&lang=js&"
import style0 from "./Home.vue?vue&type=style&index=0&id=2bb4da51&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb4da51",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/gitlab-runner/builds/5b48807f/0/c.gassner/logbook/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib'
import { VBottomSheet } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
import { VCalendar } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardActions } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VChip } from 'vuetify/lib'
import { VCombobox } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VDivider } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VHover } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VRating } from 'vuetify/lib'
import { VSelect } from 'vuetify/lib'
import { VSnackbar } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VSparkline } from 'vuetify/lib'
import { VTextarea } from 'vuetify/lib'
import { VTreeview } from 'vuetify/lib'
installComponents(component, {VAlert,VBottomSheet,VBtn,VCalendar,VCard,VCardActions,VCardText,VCardTitle,VChip,VCombobox,VContainer,VDivider,VFlex,VHover,VIcon,VLayout,VRating,VSelect,VSnackbar,VSpacer,VSparkline,VTextarea,VTreeview})
